import type { FC } from "react";
import React from "react";
import { Body, Box, Pill } from "@edreamsodigeo/prisma-design-system";

import { FareCardHeader } from "./OfferCardHeader";
import PrimeLogo from "~/components/common/PrimeLogo";
import { getFareCardBorderStyle } from "~/components/common/FareCard/styles/styles";
import type { FareCardProps } from "~/components/common/FareCard/contract";

export const FareCard: FC<FareCardProps> = ({
  type = "primary",
  fareTitle,
  fareSubtitle,
  farePrice,
  fareDiscountedPrice,
  farePriceDescription,
  children,
  pillLabel,
}) => {
  const primaryCard = type === "primary";
  const showPill = primaryCard && pillLabel;

  const borderStyle = getFareCardBorderStyle(primaryCard);

  return (
    <Box
      border={borderStyle.width}
      borderColor={borderStyle.color}
      paddingX={"base"}
      paddingTop={"base"}
      borderRadius={"regular"}
    >
      {showPill && (
        <Box position={"relative"}>
          <Box position={"absolute"} sx={{ top: "-28px", right: "0" }}>
            <Pill type={"positive"} rounded>
              <Body type={"small"}> {pillLabel}</Body>
            </Pill>
          </Box>
        </Box>
      )}

      {primaryCard && (
        <Box marginBottom={"small"}>
          <PrimeLogo negative={false} size={"xs"} type={"short"} />
        </Box>
      )}
      <Box marginY={primaryCard ? "small" : undefined}>
        <FareCardHeader
          title={fareTitle}
          subtitle={fareSubtitle}
          price={farePrice}
          discountedPrice={fareDiscountedPrice}
          priceDescription={farePriceDescription}
          type={type}
        />
      </Box>

      <Box paddingY={"small"}>{children}</Box>
    </Box>
  );
};
